import { format } from 'date-fns';
import { today } from 'AppReact';
import snackbar from 'components/snackbar';
const JSZip = require('jszip');

export const downloadZip = async (attachments) => {
  let urls = [];

  attachments.map((attachment) => {
    const url = new URL(attachment.full_url ?? attachment.url);
    urls.push({ url: attachment.full_url ?? attachment.url, name: url.pathname.split('/').pop() });
  });

  try {
    snackbar({
      message: 'Download files started. It might take a while',
      args: { type: 'success' }
    });
    const zip = new JSZip();
    // Download images and add to zip

    for (const file of urls) {
      try {
        const response = await fetch(file.url);
        const blob = await response.blob();
        zip.file(file.name, blob);
      } catch (err) {
        console.error(`Failed to fetch ${file.url}:`, err);
      }
    }

    const content = await zip.generateAsync({ type: 'blob' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(content);
    link.download = `Files_${format(today(), 'MM/dd/yyyy')}.zip`;
    link.click();
    URL.revokeObjectURL(link.href);

  } catch (e) {
    snackbar({
      message: e.response?.data?.error || 'Something went wrong with the download',
      args: { type: 'error' }
    });
  }
}